import { queryKeys } from "../queryKeys";
import { getOwners, type Owner } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetOwners = ({
  accountId,
  options,
}: {
  accountId: string;
  options?: QueryOptions<Owner[]>;
}) => {
  const {
    data: owners,
    refetch,
    isLoading,
  } = useRequest(
    queryKeys.documents.owners(accountId),
    () => getOwners(accountId),
    {
      refetchInterval: false,
      ...options,
      enabled: !!accountId && (options?.enabled ?? true),
    },
  );

  return { owners, refetch, isLoading };
};

export default useGetOwners;
